module.exports = __webpack_public_path__ + "img/fatality-chart.6c64193d.png";